export default __webpack_public_path__ + "static/media/NoRacesMascot.4f3a12f0.png";